import { Spin } from 'antd';

const Loader = () => {
  return (
    <div style={{ textAlign: 'center' }}>
      <Spin />
    </div>);
};
export default Loader;
